export const HELP_CENTER_VIEW_FIELD = {
  NAME: 'name',
  URL: 'url',
  REMOVE: 'remove',
  IS_NEW: 'isNew',
  OPEN_ACCESS: 'openAccess'
} as const;
